import PropTypes from "prop-types";
import Typography from "@shared/v2/Typography";
import { ArrowUpSolidV6 } from "@shared/v2/Icomoon";

const IntegrationCard = ({ integration, onClick }) => (
  <button
    key={integration.slug}
    type="button"
    className="tw-relative tw-bg-white tw-shadow-card tw-w-[650px] tw-flex-none tw-border-solid tw-border-[1px] tw-border-gray-5 tw-p-[24px] tw-rounded-[16px] tw-flex tw-gap-[16px] tw-self-start tw-group hover:tw-bg-[#fafafa]"
    onClick={onClick}
  >
    <div className="tw-w-[164px] tw-h-[164px] tw-bg-tinted-gray-50 tw-flex-none tw-flex tw-justify-center tw-items-center tw-rounded-[16px] tw-overflow-hidden">
      <img className="tw-max-w-[124px] tw-w-full" src={integration.imageUrl} alt={integration.headline} />
    </div>
    <div className="tw-flex tw-flex-col tw-gap-[12px] tw-text-start">
      <span className="tw-text-24d">{integration.headline}</span>
      <Typography className="!tw-text-gray-50 tw-leading-[150%]">{integration.description}</Typography>
    </div>
    <ArrowUpSolidV6
      className="tw-absolute tw-bottom-[24px] tw-right-[24px] tw-transition-all tw-rotate-45 tw-self-end tw-translate-x-[-12px] tw-text-gray-50 group-hover:tw-translate-x-0 group-hover:tw-text-neutral-gray-75"
      size="xxl"
    />
  </button>
);

IntegrationCard.propTypes = {
  integration: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default IntegrationCard;
